import { render } from "./Grid.vue?vue&type=template&id=2de7b714&scoped=true"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"

import "./Grid.vue?vue&type=style&index=0&id=2de7b714&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de7b714"],['__file',"src/components/Grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2de7b714"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2de7b714', __exports__)) {
    api.reload('2de7b714', __exports__)
  }
  
  module.hot.accept("./Grid.vue?vue&type=template&id=2de7b714&scoped=true", () => {
    api.rerender('2de7b714', render)
  })

}


export default __exports__